import {apiClient} from './axios';
import {
    BuildThumbnailPromptRequest,
    BuildThumbnailPromptResponse,
    CreateThumbnailCandidateRequest,
    ThumbnailCandidate,
} from '../types/libraryThumbnail';

export const libraryThumbnailApi = {
    // 후보 목록 조회
    list: async (libraryId: number): Promise<ThumbnailCandidate[]> => {
        const result = await apiClient.get<ThumbnailCandidate[]>(
            `/admin/library/${libraryId}/thumbnails`
        );
        return result ?? [];
    },

    // 프롬프트 빌드 (LLM 보강 / 기본)
    buildPrompt: async (
        libraryId: number,
        body: BuildThumbnailPromptRequest
    ): Promise<BuildThumbnailPromptResponse> => {
        return apiClient.post<BuildThumbnailPromptResponse>(
            `/admin/library/${libraryId}/thumbnails/build-prompt`,
            body
        );
    },

    // 후보 생성
    create: async (
        libraryId: number,
        body: CreateThumbnailCandidateRequest
    ): Promise<ThumbnailCandidate> => {
        return apiClient.post<ThumbnailCandidate>(
            `/admin/library/${libraryId}/thumbnails`,
            body
        );
    },

    // 후보 선택 (해당 후보 이미지를 라이브러리 썸네일로 적용)
    select: async (libraryId: number, candidateId: number): Promise<void> => {
        await apiClient.postNoData(
            `/admin/library/${libraryId}/thumbnails/${candidateId}/select`
        );
    },

    // 후보 삭제
    delete: async (libraryId: number, candidateId: number): Promise<void> => {
        await apiClient.deleteNoData(
            `/admin/library/${libraryId}/thumbnails/${candidateId}`
        );
    },

    // 라이브러리 썸네일 비우기 (현재 wordbook/group thumbnailUrl=null)
    clearThumbnail: async (libraryId: number): Promise<void> => {
        await apiClient.deleteNoData(`/admin/library/${libraryId}/thumbnail`);
    },
};
